import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconDrop: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconDrop"><Path d="M19.5 14.1111C19.5 18.1919 16.1421 21.5 12 21.5C7.85786 21.5 4.5 18.1919 4.5 14.1111C4.5 8.30556 12 2.5 12 2.5C12 2.5 19.5 8.30556 19.5 14.1111Z" stroke="currentColor"/></CentralIconBase>;
});

export default IconDrop;
